import type { HTMLAttributes, ReactNode } from 'react';

import styles from './Badge.module.css';

/**
 * Semantic tones carry meaning and are never decorative; `accent` is the opposite - decoration that must
 * never carry meaning (STD-002 §2).
 */
export type BadgeTone = 'neutral' | 'credit' | 'debit' | 'warn' | 'accent';

export interface BadgeProps extends HTMLAttributes<HTMLSpanElement> {
  readonly tone?: BadgeTone;
  readonly children: ReactNode;
}

/**
 * A small piece of state: `Trial`, `Lapsed`, `Synced`.
 *
 * Colour is never the only signal - the badge always has words, because roughly one man in twelve cannot
 * tell the credit green from the debit rust.
 */
export function Badge({ tone = 'neutral', className, children, ...rest }: BadgeProps): React.JSX.Element {
  return (
    <span className={[styles.badge, styles[tone], className ?? ''].filter(Boolean).join(' ')} {...rest}>
      {children}
    </span>
  );
}
